import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Experiences from './pages/Experiences';
import ExperienceDetail from './pages/ExperienceDetail';
import PlanTrip from './pages/PlanTrip';
import FAQPage from './pages/FAQPage';
import Contact from './pages/Contact';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <LanguageProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-sand-50 selection:bg-amber-500 selection:text-white">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<AboutUs />} />
            <Route path="/oplevelser" element={<Experiences />} />
            <Route path="/oplevelser/:slug" element={<ExperienceDetail />} />
            <Route path="/planlaeg-din-rejse" element={<PlanTrip />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}
